export default {
    data: function () {
        return {
            tokens: ['user', 'phone'],
        };
    },
    computed: {
        preparedTokens: function () {
            return this.tokens.map(token => '###' + token.toUpperCase() + '###').concat(this.additionalData.map(ad => {
                return '###' + ad.toUpperCase() + '###'
            }));
        },
    },
    methods: {
        addToken: function (attribute = 'name') {
            const selected = window.getSelection().toString();
            const token = '###' + attribute.toUpperCase() + '###';
            const selectionStart = this.$refs.message.$el.selectionStart;

            this.model.message = this.model.message || '';

            let start = 0;
            let end = this.model.message?.length || 0;

            if (selected) {
                start = this.model.message.indexOf(selected);
                end = start + selected.length;
            } else if (selectionStart >= 0) {
                start = selectionStart;
                end = selectionStart;
            }

            this.model.message = this.model.message.substring(0, start) + token + this.model.message.substring(end);
            this.$emit('update:message', this.model.message);
            this.$store.dispatch('sms/setMessage', this.model.message);
        },

        handleKeydown: function (event) {
            if (event.key !== 'Backspace') {
                return null;
            }
            const textarea = event.target;
            const pos = textarea.selectionStart;
            const value = this.model.message;

            for (const token of this.preparedTokens) {
                const start = pos - token.length;

                if (
                    start >= 0 &&
                    value.substring(start, pos) === token
                ) {
                    event.preventDefault();

                    this.model.message =
                        value.substring(0, start) +
                        value.substring(pos);

                    requestAnimationFrame(() => {
                        textarea.selectionStart = start;
                        textarea.selectionEnd = start;
                    });

                    break;
                }
            }
        },
    }
};